<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-card-title>Document</b-card-title>
        <b-row class="mb-2" v-if="!viewOnly">
          <b-col md="12" class="mb-1">
            <b-form-file
              ref="fileInput"
              placeholder="Choose files or drop them here..."
              drop-placeholder="Drop files here..."
              multiple
              class="mt-2 d-none"
              @change="handleFileSelect"
            />
            <div class="d-flex justify-content-between">
              <b-button variant="info" @click="openFilePicker" class="mt-2"
                >Select Files</b-button
              >
              <b-tooltip target="file-tooltip" placement="bottom">
                Max file upload at a time is 10, and max size is 20 MB.
              </b-tooltip>
              <b-button variant="success" @click="uploadFiles" class="mt-2"
                >Upload Files</b-button
              >
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="my-2">
            <b-form-group label="Filter by File Name" label-for="fileNameFilter" class="mb-0">
              <b-input-group>
                <b-form-input
                  id="fileNameFilter"
                  v-model="fileNameFilter"
                  placeholder="Type to filter by file name..."
                />
                <b-input-group-append>
                  <b-button variant="outline-danger" @click="clearFilter">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-list-group flush>
          <b-list-group-item
            v-for="(file, index) in selectedFiles"
            :key="index + 100"
            class="d-flex justify-content-between align-items-center my-2"
          >
            {{ file.name }}
            <b-button size="sm" variant="danger" @click="removeFile(index)"
              >Remove</b-button
            >
          </b-list-group-item>
        </b-list-group>
        <b-table
          :items="filteredFiles"
          :fields="fields"
          striped
          responsive
          sort-by="fileName"
  sort-desc="false"
        >
          <template #cell(view_document)="row">
            <b-form-checkbox
              v-model="row.detailsShowing"
              plain
              class="vs-checkbox-con"
              @change="row.toggleDetails"
            >
              <span class="vs-checkbox"> </span>
              <span class="vs-label">{{
                row.detailsShowing ? "Hide" : "Show"
              }}</span>
            </b-form-checkbox>
          </template>
          <template #row-details="row">
            <!-- {{ row }} -->
            <b-row>
              <b-col md="12">
                <b-card class="bg-transparent mb-5">
                  <b-card-header class="justify-content-end px-0">
                    <b-dropdown
                      variant="link"
                      no-caret
                      class="chart-dropdown"
                      toggle-class="p-0"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="18"
                          class="text-body cursor-pointer"
                        />
                      </template>
                      <b-dropdown-item @click="copyToClipboard(row.item.id)">
                        Copy URL
                      </b-dropdown-item>

                      <b-dropdown-item
                        v-if="documentDetails.isDelete"
                        @click="$emit('deleteFile', row.item.id)"
                        >Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-card-header>
                  <b-card-body>
                    <b-row class="justify-content-center align-items-center">
                      <b-col
                        md="6"
                        class="d-flex flex-column justify-content-center align-items-center text-center"
                      >
                        <feather-icon icon="FolderIcon" size="50" />
                        <b-card-text>{{ row.item.fileName }}</b-card-text>
                        <div class="clipboard-container">
                          <!-- <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="$emit('downloadFile',row.item.id,row.item.fileName)"
                          > -->

                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="downloadnew(row.item.id)"
                          >
                            <feather-icon icon="ClipboardIcon" size="18" />
                            Download
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              Hide Details
            </b-button>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <!-- <div class="d-flex justify-content-center mb-1" v-if="documentLoader">
            <b-spinner variant="success" label="Spinning" block style="width: 3rem; height: 3rem"></b-spinner>
        </div> -->
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BContainer,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormFile,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BContainer,
    BTabs,
    BTab,
    BFormCheckbox,
    BFormFile,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
  },
  props: {
    documentDetails: {
      type: Object,
      default: () => ({
        isDelete: false,
        documentList: [],
      }),
    },
    viewOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fileNameFilter: "", 
      selectedFiles: [],
      acceptedFileTypes: {
        Image: [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"],
        Text: [".txt", ".csv", ".json", ".xml", ".mdf", ".cs", ".js", ".html"],
        Document: [".docx", ".doc", ".xlsx", ".xls", ".ppt", ".pptx", ".pdf"],
        Archive: [".zip", ".rar"],
      },
      fields: [
      { key: "fileName", label: "File Name", sortable: true },
      { key: "view_document", label: "View Document" },
    ],
    };
  },
  computed: {
    filteredFiles() {
      if (!this.fileNameFilter) {
        return this.documentDetails.documentList;
      }
      return this.documentDetails.documentList.filter((file) =>
        file.fileName.toLowerCase().includes(this.fileNameFilter.toLowerCase())
      );
    },
  },
  methods: {
    clearFilter() {
      this.fileNameFilter = "";
    },
    isFileTypeSupported(file, fileTypeCategory) {
      const extension = file.name.split(".").pop().toLowerCase();
      const validExtensions = this.acceptedFileTypes[fileTypeCategory];
      return validExtensions.includes(`.${extension}`);
    },
    openFilePicker() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    handleFileSelect(event) {
      var hasInvalid = false;

      Array.from(event.target.files).forEach((file) => {
        const isImage = this.isFileTypeSupported(file, "Image");
        const isText = this.isFileTypeSupported(file, "Text");
        const isDocument = this.isFileTypeSupported(file, "Document");
        const isArchive = this.isFileTypeSupported(file, "Archive");

        if (isImage || isText || isDocument || isArchive) {
          this.selectedFiles.push(file);
        } else {
          hasInvalid = true;
        }
      });

      if (hasInvalid) {
        this.$swal({
          title: "Some files were not uploaded!",
          text: "One or more of the files were not selected due to invalid type",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok",

          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          // Ensure no loader is shown initially
          showLoaderOnConfirm: false,
        });
      }

      this.$refs.fileInput.$el.value = "";
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    async shareFile(id) {
      this.fileSharingAction(id);
    },
    async uploadFiles() {
  if (this.selectedFiles.length === 0) {
    this.$swal({
      title: "No files found",
      text: "Please select at least one file to upload",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

  if (this.selectedFiles.length > 10) {
    this.$swal({
      title: "Upload Limit Exceeded",
      text: "Please upload a maximum of 10 files at a time.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  const totalFileSizeMB = this.selectedFiles.reduce(
    (total, file) => total + file.size / (1024 * 1024),
    0
  );

  if (totalFileSizeMB > 20) {
    this.$swal({
      title: "File Size Limit Exceeded",
      text: `The total file size (${totalFileSizeMB.toFixed(
        2
      )} MB) exceeds the 20 MB limit. Please reduce the file size.`,
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

  this.$emit("uploadFiles", this.selectedFiles);
  this.selectedFiles = [];
},
    getFileUrl(id) {
      return `${process.env.VUE_APP_API_URL}v1/filesharings/download/${id}`;
    },

    downloadnew(id) {
      const fileUrl = this.getFileUrl(id);
      window.open(fileUrl, '_blank');

    },
    copyToClipboard(id) {
      const fileUrl = this.getFileUrl(id);
      navigator.clipboard.writeText(fileUrl).then(
        () => {
          this.$swal({
            title: "URL Copied!",
            text: "The file URL has been copied to your clipboard.",
            icon: "success",
            confirmButtonText: "OK",
          });
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
          this.$swal({
            title: "Error!",
            text: "Failed to copy the URL. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    },
  },
  mounted() {},
};
</script>
